import { ScreenDimensions } from 'src/app/shared/models/screen.dimensions.model';

export class PublishStateModel {
  publishing: boolean;
  widgetURL: string;

  // widget dimensions
  dimensions: ScreenDimensions;
  minDimensions: ScreenDimensions;

  // developer
  selectedAppId?: number;
}
